export default __webpack_public_path__ + "static/media/operation_theatre.72442a34.png";